import { format } from "date-fns";

export const formatAuthoredDate = (
  authored: string | undefined,
  shortFormat = true,
  showTimezone = true,
): string => {
  if (!authored) return "--";

  const date = new Date(authored);
  if (shortFormat) {
    return format(date, "MM/dd/yy");
  }
  const timezoneFormat = showTimezone ? " z" : "";
  return format(date, `M/d/yyyy 'at' h:mm a${timezoneFormat}`);
};

export const formatQuestionnaireScore = (
  responseScore: number | null | undefined,
  maxScore: number | null | undefined,
  missingScoreText = "Results",
): string => {
  if (responseScore === null || responseScore === undefined)
    return missingScoreText;
  if (maxScore === null || maxScore === undefined)
    return responseScore.toString();
  return `${responseScore}/${maxScore}`;
};

/**
 * Extracts the date from an observation, prioritizing valueDateTime over effectiveDateTime.
 * This is used for health screening observations where the actual date might be stored
 * in valueDateTime instead of effectiveDateTime.
 * @param observation The observation object containing date fields
 * @returns The date string if found, undefined otherwise
 */
export const getObservationDate = (observation: {
  valueDateTime?: string;
  effectiveDateTime?: string;
}): string | undefined => {
  return observation.valueDateTime || observation.effectiveDateTime;
};
